// A round icon-only button labelled for screen readers (web/style.css .icon-btn).
import type { ButtonHTMLAttributes } from "react";
import { Icon, type IconName } from "../shared/icons";
import styles from "./IconButton.module.css";

export function IconButton({ icon, label, className, ...rest }: { icon: IconName; label: string } & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" aria-label={label} title={label} className={className ? `${styles.btn} ${className}` : styles.btn} {...rest}>
      <Icon name={icon} />
    </button>
  );
}
